import { Mail, MessageCircle, Clock, Phone } from "lucide-react";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Reveal } from "@/components/Reveal";
import { CONTACT_EMAIL, WHATSAPP_NUMBER, PHONE_DISPLAY } from "@/data/content";

export default function Contact() {
    return (
        <main className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24" data-testid="contact-page">
            <div className="grid items-start gap-14 lg:grid-cols-5">
                <Reveal className="lg:col-span-2">
                    <p className="text-xs font-medium uppercase tracking-[0.28em] text-saffron">Contact Us</p>
                    <h1 className="mt-4 font-serif text-4xl font-semibold leading-[1.02] tracking-tight text-ink sm:text-5xl">
                        Let's talk about your child's <em className="italic text-saffron">next step</em>.
                    </h1>
                    <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground md:text-lg">
                        Questions about subjects, scheduling, pricing or anything else? Send us a message — a real person
                        from our team replies within 24 hours, wherever in the world you are.
                    </p>
                    <div className="mt-10 space-y-5" data-testid="contact-details">
                        <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-4 text-sm text-ink transition-colors hover:text-saffron" data-testid="contact-email-link">
                            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-saffron-soft"><Mail className="h-5 w-5 text-saffron-dark" /></span>
                            {CONTACT_EMAIL}
                        </a>
                        <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 text-sm text-ink transition-colors hover:text-saffron" data-testid="contact-whatsapp-link">
                            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-teal-soft"><MessageCircle className="h-5 w-5 text-teal" /></span>
                            Chat with us on WhatsApp
                        </a>
                        <a href={`tel:+${WHATSAPP_NUMBER}`} className="flex items-center gap-4 text-sm text-ink transition-colors hover:text-saffron" data-testid="contact-phone-link">
                            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-saffron-soft"><Phone className="h-5 w-5 text-saffron-dark" /></span>
                            {PHONE_DISPLAY}
                        </a>
                        <div className="flex items-center gap-4 text-sm text-ink">
                            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-sand"><Clock className="h-5 w-5 text-teal" /></span>
                            Lessons 7 days a week — scheduled in your time zone
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.15} className="lg:col-span-3">
                    <div className="rounded-3xl border border-border bg-sand p-8 card-shadow lg:p-10">
                        <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink">Send us a message</h2>
                        <p className="mt-2 text-sm text-muted-foreground">We usually reply the same day.</p>
                        <div className="mt-8">
                            <EnquiryForm />
                        </div>
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
